import { render, staticRenderFns } from "./StaffCoachingN.vue?vue&type=template&id=4e0434ae"
import script from "./StaffCoachingN.vue?vue&type=script&lang=js"
export * from "./StaffCoachingN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports